import { Highlight, Snippet } from 'react-instantsearch-hooks-web';
import { classnames } from 'tailwindcss-classnames';
import { HitProps } from './_types';
import { HitHeadline } from './_HitHeading';

export const renderAnnouncementDate = (result: string | number | Date) => {
  const dateString = new Date(result);
  const options: {} = { year: 'numeric', month: 'long', day: 'numeric' };
  return (
    <div className={classnames('mb-2')}>{dateString.toLocaleDateString(undefined, options)}</div>
  );
};

export const AnnouncementListingHit = ({ hit }: HitProps) => {
  return (
    <div>
      <HitHeadline hit={hit}>
        <Highlight hit={hit} attribute="pageTitle" />
      </HitHeadline>
      {hit.publishedDate && renderAnnouncementDate(hit.publishedDate)}
      <Snippet
        hit={hit}
        attribute="description"
        className={classnames('line-clamp-4', 'md:line-clamp-2', 'text-black')}
      />
    </div>
  );
};
